import { Tooltip } from 'bootstrap';

import { InPlaceEditor, MultiSelect as InPlaceEditorMultiSelect, Rte } from '@syncfusion/ej2-inplace-editor';
import { HtmlEditor, Image, Link, RichTextEditor, Toolbar } from '@syncfusion/ej2-richtexteditor';

import { EditableClientProps } from '@/shared/types/editable';

import { initDateCheckbox } from '@/front/editable/date-checkbox';
import { initDatePicker } from '@/front/editable/date-picker';
import { initDropDownList } from '@/front/editable/drop-down-list';
import { initInPlaceEditor } from '@/front/editable/in-place-editor';
import { initMultiSelect } from '@/front/editable/multi-select';
import { initRichTextEditor } from '@/front/editable/rich-text-editor';
import { setField, setProps } from '@/front/editable/state';
import { initSwitch } from '@/front/editable/switch';
import { initTextBox } from '@/front/editable/text-box';
import { parseProps } from '@/front/editable/utils';
import { dispatch } from '@/front/event';

InPlaceEditor.Inject(InPlaceEditorMultiSelect, Rte);
RichTextEditor.Inject(Toolbar, HtmlEditor, Link, Image);

document.addEventListener('DOMContentLoaded', () => {
  initEditables();
  focusFirstInput();
  dispatch('editablesReady');
});

const initEditables = () => {
  for (const e of document.querySelectorAll('.editable')) {
    initEditable(e as HTMLElement);
  }
};

const initEditable = (e: HTMLElement) => {
  const p = parseProps(e.dataset.props!);

  setProps(p.id, p);
  setField(p.id, p.field);

  initControl(p, e);
  initDataAttributes(p, e);
  initTooltip(p, e);
};

const initControl = (p: EditableClientProps, e: HTMLElement) => {
  if (p.type === 'Switch') {
    initSwitch(p, e);
  } else if (!p.modelId || p.editMode === 'Form') {
    if (p.type === 'Text' || p.type === 'Float' || p.type === 'Integer') {
      initTextBox(p, e);
    } else if (p.type === 'Date') {
      initDatePicker(p, e);
    } else if (p.type === 'DropDownList') {
      initDropDownList(p, e);
    } else if (p.type === 'MultiSelect') {
      initMultiSelect(p, e);
    } else if (p.type === 'RTE') {
      initRichTextEditor(p, e);
    }
  } else {
    initInPlaceEditor(p, e);
  }
};

const initDataAttributes = (p: EditableClientProps, e: HTMLElement) => {
  e.setAttribute('data-model', p.modelName);
  e.setAttribute('data-field', p.field);

  if (!p.modelId) e.setAttribute('data-new', 'true');
  if (p.readOnly) e.setAttribute('data-read-only', 'true');
  if (!(p.allowManualEntry ?? true)) e.setAttribute('data-manual-entry', 'false');
  if (p.fullwidth) e.setAttribute('data-fullwidth', 'true');
  if (p.multiline) e.setAttribute('data-multiline', 'true');
  if (p.obscured) e.setAttribute('data-obscured', 'true');
};

const initTooltip = (p: EditableClientProps, e: HTMLElement) => {
  if (p.tooltip) {
    new Tooltip(e.closest('.editable-wrapper')!, {
      title: p.tooltip,
      placement: 'right',
    });
  }
};

const focusFirstInput = () => {
  const firstInput = document.querySelector('.editable[data-new] input') as HTMLInputElement | null;

  if (firstInput) firstInput.focus();

  for (const element of document.querySelectorAll('.editable-date-check-box')) {
    initDateCheckbox(element as HTMLInputElement);
  }
};
